"use strict";

import angular from "angular";
import { AccountingPlanEntity } from "../../entity/AccountingPlanEntity";
import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";
import { RolesUtils } from "../../utils/roles/roles";
import { nucontersUsers } from "../../utils/users-roles/users-roles";
import { PlanMockNew } from "../../shared/constants/plans.constants";

angular.module("nucont.accountings").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accountings", {
            url: "contabilidades",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accountings" */ "./accountings.entry"
                ).then(() => $ocLazyLoad.inject("nucont.accountings"));
            },
            views: {
                "main@": {
                    component: "adminLayoutComponent"
                },
                "admin@nucont.accountings": {
                    component: "accountingsComponent"
                }
            },
            data: {
                rolesGuard: [...nucontersUsers],
                layoutConfig: {
                    model: "LayoutConfigModel1",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "moduleTitle.text",
                            value: "Administrativo"
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.enabled",
                            value: true
                        }
                    ]
                }
            },
            resolve: {
                jwtVerified: [
                    "JWTService",
                    (JWTService) => JWTService.verifyTokenOnce()
                ],
                validationsContract: [
                    "NavigationService",
                    (NavigationService) => {
                        const accountingPlanEntity = new AccountingPlanEntity(
                            PlanMockNew
                        );

                        NavigationService.setValidationsContract(
                            accountingPlanEntity
                        );
                    }
                ],
                user: [
                    "$state",
                    ($state) => {
                        return new Promise((resolve, reject) => {
                            const checkUser = () => {
                                if (new UserDataAdapter().user()?.role) {
                                    if (
                                        !RolesUtils.userIsInRole({
                                            roles: [
                                                "Super",
                                                "Sucesso",
                                                "NuHacker",
                                                "ChampionsLeads",
                                                "Heads"
                                            ]
                                        })
                                    ) {
                                        $state.go("nucont.companies");
                                        return resolve(true);
                                    }
                                    return resolve(true);
                                } else {
                                    setTimeout(() => {
                                        checkUser();
                                    }, 1000);
                                }
                            };
                            checkUser();
                        });
                    }
                ]
            }
        })
        .state("nucont.accountings.customers", {
            // `?aba` deixa o recorte na URL, para o link ser compartilhável e sobreviver ao
            // refresh. `reloadOnSearch: false` porque trocar de aba é trocar de filtro dentro da
            // mesma tela — remontar o componente perderia a busca e a página atual.
            url: "/clientes?aba",
            reloadOnSearch: false,
            views: {
                "accounting@nucont.accountings": {
                    component: "accountingsSuperlogicaComponent"
                }
            }
        })
        .state("nucont.accountings.trial", {
            url: "/trial",
            views: {
                "accounting@nucont.accountings": {
                    component: "accountingsTrialComponent"
                }
            }
        });
}
